export const getNestedKey = (kind: 'bidhi' | 'sankalpa', ownerId: unknown) =>
  `${kind}:${String(ownerId ?? 'unknown')}`;

export const getNestedTextId = (containerKey: string, localLineId: string) =>
  `${containerKey}::${localLineId}`;

export const getLegacyNestedTextId = (containerKey: string, localLineId: string) => {
  const m = /:id:(.+)$/.exec(localLineId);
  const raw = m?.[1];
  if (!raw) return null;
  return `${containerKey}::${raw}`;
};

export const stableNestedLineId = (containerKey: string, line: any, fallbackIdx: number) => {
  if (line?.id != null) return `${containerKey}:id:${String(line.id)}`;
  const order = line?.order != null ? String(line.order) : String(fallbackIdx);
  const content = String(line?.content ?? '');
  let hash = 0;
  for (let i = 0; i < content.length; i++) {
    hash = (hash * 31 + content.charCodeAt(i)) >>> 0;
  }
  return `${containerKey}:o:${order}:h:${hash}`;
};

export const getSankalpaHeaderKey = (linkId: number) => `header:sankalpaLink:${linkId}`;

export const getBidhiHeaderKey = (bidhiId: number) => `header:bidhi:${bidhiId}`;

export const isHeaderEditKey = (key: string) => key.startsWith('header:');

export const getGranthaReferenceKey = (refId: number) => `grantha:ref:${refId}`;

export const isGranthaStyleEditKey = (key: string) => key.startsWith('grantha:ref:');

export const parseLineIdFromNestedTextId = (nestedTextId: string): number | undefined => {
  const m = /:id:(\d+)$/.exec(nestedTextId);
  if (!m) return undefined;
  const id = Number(m[1]);
  return Number.isFinite(id) ? id : undefined;
};
